import { ModuleWithProviders, NgModule } from '@angular/core';
import { ProfileDetailsDispatcher, ProfileDispatcher, ProfileEditDispatcher } from '@spaq/core';
import { ProfileDetailsStore } from '@spaq/core/stores/profile-details-store';
import { ProfileEditStore } from '@spaq/core/stores/profile-edit-store';
import { ProfileStore } from '@spaq/core/stores/profile-store';
import {
	PROFILE_DETAILS_DISPATCHER,
	PROFILE_DETAILS_STORE,
	PROFILE_DISPATCHER,
	PROFILE_EDIT_DISPATCHER,
	PROFILE_EDIT_STORE,
	PROFILE_STORE
} from '@spaq/injection';
import { FormModule } from '@spaq/shared/components/forms';
import { PipesModule, SharedCommonModule, SharedComponentsModule, SharedFormModule } from '@spaq/shared';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { ProfilFormComponent, ProfilInfosComponent, ProfilInfosItemComponent } from './components';
import { ProfilDetailsComponent, ProfilEditComponent } from './pages';
import { ProfilEdit2FAComponent } from '@spaq/modules/profile/pages/profil-2fa.component';
import { MessageStateModule } from '@spaq/shared/components/message-state';

@NgModule({
	imports: [IndicatorsModule, SharedComponentsModule, PipesModule, FormModule, SharedCommonModule, SharedFormModule, MessageStateModule],
	declarations: [
		ProfilDetailsComponent,
		ProfilInfosComponent,
		ProfilFormComponent,
		ProfilEditComponent,
		ProfilInfosItemComponent,
		ProfilEdit2FAComponent
	],
	exports: [ProfilDetailsComponent, ProfilEditComponent]
})
export class ProfileModule {
	static forRoot(): ModuleWithProviders<ProfileModule> {
		return {
			ngModule: ProfileModule,
			providers: [
				{ provide: PROFILE_DISPATCHER, useClass: ProfileDispatcher },
				{ provide: PROFILE_EDIT_DISPATCHER, useClass: ProfileEditDispatcher },
				{ provide: PROFILE_DETAILS_DISPATCHER, useClass: ProfileDetailsDispatcher },
				{ provide: PROFILE_STORE, useClass: ProfileStore },
				{ provide: PROFILE_EDIT_STORE, useClass: ProfileEditStore },
				{ provide: PROFILE_DETAILS_STORE, useClass: ProfileDetailsStore }
			]
		};
	}
}
